import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Acompanhando from './acompanha/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route  } from "react-router";


//Fontes
import "./fonts/Fontes.css";
import "./fonts/FontAwesome.ttf";
import "./fonts/FontAwesome5_Brands.ttf";
import "./fonts/FontAwesome5_Brands.ttf";
import "./fonts/FontAwesome5_Solid.ttf";
import "./fonts/AntDesign.ttf";
import "./fonts/Entypo.ttf";
import "./fonts/EvilIcons.ttf";
import "./fonts/Feather.ttf";
import "./fonts/Fontisto.ttf";
import "./fonts/Foundation.ttf";
import "./fonts/Ionicons.ttf";
import "./fonts/MaterialCommunityIcons.ttf";
import "./fonts/MaterialIcons.ttf";
import "./fonts/Octicons.ttf";
import "./fonts/SimpleLineIcons.ttf";
import "./fonts/Zocial.ttf";
//Fontes


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/c/:xd" element={<Acompanhando />} />
      <Route path="/:id" element={<App />} />
      <Route path="/t/:id" element={<App />} />
      <Route path="*" element={<App />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
